const SCREEN = {
  BROWSE: 'Browse',
  APP_CELEBRATION: 'App Celebration',
};

const ACTION = {
  ERROR: 'Error',
  PAGE_VIEW: 'Page View',
};

export { ACTION, SCREEN };
